interface AgentBuilderStrings {
  KNOWLEDGE_BASE: {
    ADD_SOURCES_HEADER: string
    SOURCES_TABS: {
      FILES: string
      TEXT: string
      LINKS: string
      INTEGRATE: string
    }
  }
}

interface LanguageTexts {
  [key: string]: string | AgentBuilderStrings
  AGENT_BUILDER_STRING: AgentBuilderStrings
}

const languageObj: LanguageTexts = {
  ADD_NEW_APP_CARD_REGION_TEXT:
    'Every region will work for all your users worldwide but will give better performance for users of that region.',
  US_HIPAA_APP_REQUEST_SUCCESS_MSG_HEADER: 'US Hipaa Compliant App Request Successfull!',
  US_HIPAA_APP_REQUEST_SUCCESS_MSG_BODY:
    'Hi, your request for a US Hipaa Compliant App has been registered. Our teams will get in touch with you soon.',
  APP_EXPIRED_MODAL_MSG:
    'Looks like your app has been expired! To continue using this app, select a plan to subscribe.',
  APP_EXPIRED_BANNER_MSG: 'Your plan has expired. Please subscribe to continue using this app.',
  APP_CONGRATULATIONS_MODAL_TITLE:
    'Congratulations! Your new app has been successfully created and is now on the Build plan, giving you full access to all the features CometChat has to offer. Being on this plan enables you to seamlessly integrate our suite of real-time messaging, voice, and video calling functionalities into your app or website.',
  APP_CONGRATULATIONS_MODAL_DESCRIPTION:
    'If you do not select a plan, we will automatically select our Free plan for you.',
  APP_CARD_EXPIRED_APP_HOVER_TITLE: 'Your plan has expired. Click to choose a plan',
  APP_CREATION_FAILED:
    'You have reached the limit for Developer plan apps. Please subscribe to a paid plan from the plans and billings page, or contact us if you have any questions.',
  APP_CREATION_FAILED_EXCEPTION:
    'There was a problem creating an app, please try again. If the error persists please contact our customer support.',
  SWITCHING_DASHBOARD_TITLE: 'Switching Back',
  SWITCHING_DASHBOARD_DES:
    'Please take a moment to let us know what you feel about the new dashboard. Your feedback will help us improve.',
  QUICK_START_HEADER_TEXT_1: 'Setup Your Application ',
  QUICK_START_HEADER_TEXT_2:
    'You can start integration in your product or experience our demo on your desktop or device',
  QUICK_START_V1_MIGRATION_HEADER_TEXT_1: 'Upgrading from v1',
  QUICK_START_V1_MIGRATION_HEADER_TEXT_2: 'Learn how to upgrade from v1.x to v2',
  SCHEDULE_DELETE_APPLICATION_BANNER_MSG:
    'This app has been disabled. To restore, please contact us.',
  SCHEDULE_DELETE_APPLICATION_BOX_MSG:
    'Once you initiate the application deletion request, the app will be disabled and will be queued for deletion within the next 24 hours.',
  DELETE_APPLICATION_SETTINGS:
    'Once you delete an application, there is no going back. The application will be scheduled to be deleted after 30 days.',
  RESTORE_DELETE_APPLICATION_BOX_MSG: 'This application is scheduled to be deleted in ',
  APP_EXPIRED_BANNER_MSGS: 'To start using this application please subscribe',
  BILLING_HISTORY:
    "You can view and download all your previous invoices here. If you've just made a payment, it may take a few hours for it to appear.",
  CANCEL_SUBSCRIPTION:
    "After cancelling, you'll be on Startup Plan until the end of the current billing period. ",
  DELETE_APPLICATION_NOT_ALLOWED_MODAL_MSG:
    'We request you to unsubscribe the current plan of this app and then proceed to delete the app.',
  CUSTOM_PLAN_UNSUBSCRIBE_MODAL_MSG:
    'You are currently subscribed to a custom plan. To make changes to your plan or to add additional features, please Contact Us.',
  LEGACY_PLAN_UNSUBSCRIBE_MODAL_MSG:
    'You are currently subscribed to a legacy plan. To make changes to your plan or to add additional features, please Contact Us.',
  CUSTOM_PLAN_V1_APPS_FREE_UNSUBSCRIBE_MODAL_MSG:
    'Looks like you\u2019re using CometChat v1. We are no longer supporting this version. Please create a new app and subscribe.',
  SUBSCRIPTION_CANCELLATION_END_OF_TERM_MODAL_TITLE: 'Unsubscribe request registered',
  SUBSCRIPTION_CANCELLATION_END_OF_TERM_MODAL_DESCRIPTION:
    "Your request to unsubscribe has been registered. Your plan won't be renewed and your subscription will be canceled on ",
  SUBSCRIPTION_CANCELLATION_END_OF_TERM_MODAL_NOTE:
    'You can always go ahead and reactivate your subscription or contact us in case you face any issues. We look forward to serving you again!',
  CUSTOM_PLAN_V1_APPS_FREE_UNSUBSCRIBE_MODAL_TITLE: 'Sorry, v1 apps are now deprecated',
  CUSTOM_PLAN_UNSUBSCRIBE_MODAL_TITLE: 'Want to change/cancel your plan?',
  CHILD_PLAN_CHANGE_PLAN_MODAL_TITLE: 'Want to change/cancel your plan?',
  NON_CUSTOM_PLAN_CANCELS_ON: 'Your subscription will be canceled on',
  PHASE_2_PLAN_EXTENSION_ADD_RESTRICTION:
    'This extension is not present in your current plan. Please upgrade to a higher plan to add this extension.',
  PHASE_2_NEBULA_PLAN_EXTENSION_ADD_RESTRICTION:
    'This extension is not present in your current plan. If you wish to add this extension then please contact us.',
  ANALYTICS_COMING_SOON_MSG:
    'We will be launching our weekly and monthly analytics soon! Stay tuned!',
  CHILD_PLAN_CHANGE_PLAN_MODAL_MSG:
    "This app's plan & billing is linked to another app. Please visit your primary app's billing to modify your plan.",
  CUSTOM_PLAN_EXTENSION_ADD_RESTRICTION:
    'This extension is not present in your plan. Please contact us if you want to add this extension.',
  APP_ON_TRIAL_BANNER_MSG:
    'You are currently on a trial plan. Trial plans are heavily rate limited. Please subscribe before you go live to lift these restrictions.',
  LEGACY_PLAN_NEW_EXTENSION_ADD_RESTRICTION:
    'This extension is not present in your current plan. Please upgrade to a higher plan to add this extension.',
  CHAT_WIDGET_EXTENSION_TOOLTIP:
    'This feature is managed directly by the extension. Please check the extension settings for more information',
  CHAT_WIDGET_NOT_SUPPORTED_FEATURE_TOOLTIP:
    'This feature is not supported in your current plan. Please upgrade to a higher plan to enable this feature',
  CHAT_WIDGET_NOT_SUPPORTED_ENABLED_FEATURE_TOOLTIP:
    'This feature is not supported in your current plan. Please upgrade to a higher plan to use this feature in the widget',
  SUBSCRIPTION_DOWNGRADE_END_OF_TERM_MODAL_TITLE: 'Plan Downgrade request registered',
  SUBSCRIPTION_DOWNGRADE_END_OF_TERM_MODAL_DESCRIPTION:
    'Your request to downgrade your plan has been registered. Your plan will be downgraded on ',
  SUBSCRIPTION_DOWNGRADE_END_OF_TERM_MODAL_NOTE:
    'You can always go ahead and choose another plan or contact us in case you face any issues.',
  SUBSCRIPTION_DOWNGRADE_END_OF_TERM_CANCELLED_MODAL_TITLE: 'Plan Downgrade request cancelled',
  SUBSCRIPTION_DOWNGRADE_END_OF_TERM_CANCELLED_MODAL_DESCRIPTION:
    'Your request to cancel your plan downgrade has been processed. Your active plan is now  ',
  SUBSCRIPTION_DOWNGRADE_END_OF_TERM_CANCELLED_MODAL_NOTE:
    'You can always go ahead and choose another plan or contact us in case you face any issues.',
  NON_CUSTOM_PLAN_DOWNGRADES_ON: 'Plan will be downgraded on',
  CHAT_WIDGET_POLLS_EXTENSION_TOOLTIP:
    'To use this feature, please ensure the Polls extension is enabled. Please check the extension settings for more information',
  CHAT_WIDGET_STICKERS_EXTENSION_TOOLTIP:
    'To use this feature, please ensure the Stickers extension is enabled. Please check the extension settings for more information',
  CHAT_WIDGET_REACTIONS_EXTENSION_TOOLTIP:
    'To use this feature, please ensure the Reactions extension is enabled. Please check the extension settings for more information',
  TEAM_INVITATION_ACCEPTED_SIGNUP_MESSAGE:
    'Thank you for accepting the invitation! Please sign up to continue',
  TEAM_INVITATION_ACCEPTED_LOGIN_MESSAGE:
    'Thank you for accepting the invitation! Please login to continue',
  TEAM_MANAGEMENT_NOT_SUPPORTED_FEATURE_TOOLTIP:
    'This feature is not supported in your current plan. Please upgrade to a higher plan to enable this feature',
  TEAM_OWNER_LEAVE_COLLABORATION_WARNING:
    'As the app owner, you are not permitted to leave the collaboration. Please transfer ownership to an Active collaborator first, to leave collaboration.',
  ANALYTICS_NOT_SUPPORTED_FEATURE_TOOLTIP:
    'Analytics is not supported in your current plan. Please upgrade to a higher plan to enable this feature',
  CHAT_WIDGET_COLLABORATIVE_DOCUMENT_EXTENSION_TOOLTIP:
    'To use this feature, please ensure the Collaborative Document extension is enabled. Please check the extension settings for more information',
  CHAT_WIDGET_COLLABORATIVE_WHITEBOARD_EXTENSION_TOOLTIP:
    'To use this feature, please ensure the Collaborative Whiteboard extension is enabled. Please check the extension settings for more information',
  CHAT_WIDGET_MESSAGE_TRANSLATION_EXTENSION_TOOLTIP:
    'To use this feature, please ensure the Message Translation extension is enabled. Please check the extension settings for more information',
  ACTIVE_PLAN_UNSUBSCRIBE_RESTRICTED_MSG: 'Contact us if you would like to modify this plan.',
  BILLNG_MOBILE_VIEW_MESSAGE: 'Plans & Billing is best viewed and managed on a desktop browser.',
  BILLNG_MOBILE_VIEW_MESSAGE_DESC:
    'To change/modify your plan, please visit this area on any desktop browser.',
  FEATURE_RESTRICTED_TOOLTIP:
    'This feature is not supported in your current plan. Please upgrade to a higher plan to enable this feature',
  FEATURE_RESTRICTED_TOOLTIP2: 'To enable this feature please contact us.',
  CHAT_WIDGET_EMOJIS_EXTENSION_TOOLTIP:
    'To use this feature, please ensure the Emojis extension is enabled. Please check the extension settings for more information',
  CHAT_WIDGET_UPGRADE_PLAN_ON_RESTRICTED_FEATURE: 'Upgrade your plan to unlock this feature',
  EXTENSION_NOT_SUPPORTED_TOOLTIP:
    'This extension is not supported in your current plan. Please upgrade to a higher plan to enable this extension',
  MIGRATE_APP_REQUEST_MSG:
    'Start migrating your app version to v3 and experience major performance improvements and exciting upcoming features!',
  MIGRATE_APP_SUCCESS_MSG_HEADER: 'Response Recorded',
  MIGRATE_APP_SUCCESS_MSG_BODY:
    'Your confirmation to migrate your app to Version 3 has been recorded, our team will get in touch with you soon.',
  RESTORE_APP_REQUEST_MSG: 'Hey there! Would you like to restore your deleted app?',
  IMPORT_USERS_REQUEST_MSG:
    'Can you tell us where your user information is currently stored? Here are some options',
  CONTACT_TO_JOIN_BETA:
    ' This page is only accessible to beta users of the redesigned dashboard. Please contact us to be a part of the beta user group.',
  ANNUAL_PLAN_CONTACT_US_MESSAGE:
    'You are currently subscribed to an annual plan. To make changes to your plan or to add additional features, please Contact Us.',
  BILLING_HISTORY_OVERAGES_TOOLTIP:
    "If Overages are present then Overages from the previous month will be added in from the next month month's bill amount",
  CUSTOM_INSTRUCTIONS_TOOLTIP:
    'Custom instructions allows you to add preferences or requirements that you\u2019d like CometChat AI to consider when generating its responses. Providing a brief history/use case of your app will be helpful.',
  ADVANCED_WEBHOOK_HELP_TEXT:
    "This hook isn't available in your current plan. To unlock this feature, please consider upgrading your plan.",
  PERSONALITY_PROMPT_TOOLTIP:
    'Instruction prompt allows you to add a unique instruction to a CometChat Bot. Providing a brief description of its character, tone, or style will be helpful.',
  PREVIEW_MODE_MODERATION:
    'Preview Mode - Upgrade your plan to enable Moderation features for your app',
  PREVIEW_MODE_NOTIFICATION:
    'Preview Mode - Upgrade your plan to enable Notifications for your app',
  PREVIEW_MODE_MODERATION_RULES:
    'Preview Mode -  Enhance your moderation capabilities! Upgrade your plan to unlock the powerful rule creation feature.',
  PREVIEW_MODE_EMAIL_NOTIFICATION:
    'Preview Mode - Upgrade your plan to enable Email notifications for your app',
  PREVIEW_MODE_SMS_NOTIFICATION:
    'Preview Mode - Upgrade your plan to enable SMS notifications for your app',
  PREVIEW_MODE_NOTIFICATION_PREFERENCES:
    'Preview Mode - Upgrade your plan to customize Notification Preferences for your app',
  PREVIEW_MODE_NOTIFICATION_TEMPLATES_SOUNDS:
    'Preview Mode - Upgrade your plan to customize Notification Templates and Sounds for your app',
  TOKEN_BASED_FILE_ACCESS_CONFIRMATION_MESSAGE:
    'Token based file access cannot be disabled once its enabled. This feature requires SDKs/UI Kits versions 4.0 and above. Would you like to proceed?',
  ENHANCED_MESSAGING_STATUS_CONFIRMATION_MESSAGE:
    'Read and delivery receipts in group chats, as well as the ability to mark messages as unread, cannot be disabled once enabled. This feature requires SDKs/UI Kits versions 4.0 and above. Would you like to proceed?',
  CREATE_APP_APPLICATION_NAME_INFO: 'This will be the name of your application on CometChat',
  CREATE_APP_INDUSTRY_INFO: 'This will help customize your AI & Insights feature',
  CREATE_APP_REGION_INFO:
    'This is where your CometChat data will reside. Your users can chat from anywhere in the world.',
  CREATE_APP_TECHNOLOGY_INFO:
    'This will help customize your onboarding. This is just the first technology you are going to integrate; you can always integrate with more technologies later.',

  AGENT_BUILDER_STRING: {
    KNOWLEDGE_BASE: {
      ADD_SOURCES_HEADER: 'Add Sources',
      SOURCES_TABS: {
        FILES: 'Files',
        TEXT: 'Text',
        LINKS: 'Links',
        INTEGRATE: 'Integrate',
      },
    },
  },
}

const customLanguageTexts: LanguageTexts = languageObj
export default customLanguageTexts
